import React,{useState} from 'react';
import ChartPreview from '../../components/ReportPage/CharPreview/ChartPreview';
import DataSelector from '../../components/ReportPage/DataSelector/DataSelector';
import Button from '../../components/common/Button/Button';
import styles from './Report.module.css';
import Footer from '../../components/common/Footer/Footer';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line } from 'recharts';
import { useMediaQuery } from '@mui/material';
import { saveAs } from 'file-saver';


const Report = () => {
  const isLargeScreen = useMediaQuery('(min-width:600px)');
  const [filterValues, setFilterValues] = useState(null);
  const [chartData, setChartData] = useState([]);


  const saveChartDataToCSV = () => {
    if (chartData.length === 0) {
      alert('No data available to export.');
      return;
    }
    console.log(chartData.length)
    const headers = Object.keys(chartData[0]);
    const csvContent =
      headers.join(',') +
      '\n' +
      chartData
        .map((row) => headers.map((header) => (row[header] ? row[header] : '')).join(','))
        .join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, 'chart_data.csv');
  };


  const handleChartData = (value) => {
    setChartData(value);
  };

  const handleFilterChange = ({ startDate: start, endDate: end, dataType, location }) => {
    setFilterValues({ start, end, dataType, location });
    // alert(`Filter values on data page: Start Date: ${start}, End Date: ${end}, Data Type: ${dataType}, Location: ${location}`);
  };


   // Conditionally set chart width based on the screen width
 const chartWidth = isLargeScreen ? 660 : 350;
  return (
    
    <div className={styles.reportPage}>
      <DataSelector onFilterChange={handleFilterChange} />
      <div className={styles.outerGraph}>
  {filterValues ? (
    <ChartPreview
      startDate={filterValues.start}
      endDate={filterValues.end}
      dataType={filterValues.dataType}
      location={filterValues.location}
      onChartDataLoad ={handleChartData}
      
    />
  ) : (
    <div>
    <h2 className={styles.titleh2}>Anteprima dati</h2>
<LineChart className={styles.chart} width={chartWidth} height={300} margin={{
        top: 10,
        right: 10,
        left: -25,
        bottom: -10,
      }}>
  <defs>
    <linearGradient id="dummyFill" x1="0" y1="0" x2="0" y2="1">
      <stop offset="5%" stopColor="#dcdcdc" stopOpacity={0.8} />
      <stop offset="95%" stopColor="#dcdcdc" stopOpacity={0} />
    </linearGradient>
  </defs>
  <CartesianGrid strokeDasharray="4" />
  <XAxis
    dataKey="dt"
    stroke="white"
    tickFormatter={(tick) => new Date(tick).toLocaleTimeString('it-IT', {hour: '2-digit', minute: '2-digit'})}
  />
  <YAxis
    stroke="white"
    tickFormatter={(tick) => Math.floor(tick)}
  />
  <Tooltip
    formatter={(value, name, props) => [new Date(props.payload.dt).toLocaleString(), value]}
  />
  <Legend />
  <Line  type="monotone" dataKey={'valori'} stroke="#8884d8" dot={false} strokeWidth={1} fill="url(#dummyFill)" />
  <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#8884d8">
  Seleziona i dati da visualizzare
  </text>
</LineChart>
</div>
  )}
</div>

      <div className={styles.downloadSection}>
      <h2 className={styles.titleh2}>
        Scarica
      </h2>
      <div className={styles.buttonCover}>
      <Button text="CSV" onClick={saveChartDataToCSV} />
      <Button text="PDF" onClick={() => window.print()} />
      </div>
    </div>
      <Footer></Footer>

    </div>
  );
};

export default Report;